export const CONTEXTUAL_REPORT_ID = 'contextual';
